import { Dimension, MMDataState, TimeframeData } from '../types';

export const getDimensionLevelTotalData = (
  state: MMDataState,
  dimension: Dimension,
) => {
  switch (dimension) {
    case Dimension.campagin:
      return state.totalByCampaignId;
    case Dimension.media:
      return state.totalByMedia;
    case Dimension.campaignGroup:
      return state.totalByCampaignGroup;
  }
};

export const getDimensionLevelTimeframeData = (
  data: TimeframeData,
  dimension: Dimension,
) => {
  switch (dimension) {
    case Dimension.campagin:
      return data.byCampaignId;
    case Dimension.media:
      return data.byMedia;
    case Dimension.campaignGroup:
      return data.byCampaignGroup;
  }
};
